import React, { useState, useRef, useEffect } from "react";
import { SelectContainer, SelectDropdown, SelectOption } from "./index.styled";
import arrowDownIcon from "../../../assets/icons/arrow-down.webp";

export interface SelectOption {
  value: string | number;
  label: string;
}

interface CustomSelectProps {
  options: SelectOption[];
  value: string | number | undefined;
  onChange: (value: string | number) => void;
  placeholder?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  value,
  onChange,
  placeholder = "בחר",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);

  const selectedOption = options.find((option) => option.value === value);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleOptionClick = (optionValue: string | number) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <SelectContainer ref={selectRef} $isOpen={isOpen}>
      <button onClick={handleButtonClick} className="select-button">
        {selectedOption ? selectedOption.label : placeholder}
        <img
          src={arrowDownIcon}
          alt="Dropdown arrow"
          className="dropdown-arrow"
        />
      </button>

      {isOpen && (
        <SelectDropdown>
          {options.map((option) => (
            <SelectOption
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              className={value === option.value ? "selected" : ""}
            >
              {option.label}
            </SelectOption>
          ))}
        </SelectDropdown>
      )}
    </SelectContainer>
  );
};

export default CustomSelect;
